export const findAndRemoveRegExp = (template: string, regExp: RegExp): [string, RegExpMatchArray[]] => {
  const findings = template.matchAll(regExp);
  const newStr = template.replace(regExp, "");

  return [newStr, Array.from(findings)];
};
